<template>
  <div>
    <div :class="s.wrap">
      <div v-if="flag.loading.getContext">
        読み込み中です...
      </div>
      <div v-else-if="passenger && area && !flag.registedOrderResult">
        <div class="bdr-b pb-4 bdr-bold">
          <div class="d-flex align-items-center">
            <p class="fw-bold">乗車人数</p>
          </div>
          <div>
            <!-- 親の乗客タイプごとに人数を増減し、1人ずつオプション（例: QR支払い）を選ぶ（reservation 型の DemandOrderResult と同じ形） -->
            <div v-for="group in passengerTypeGroups" :key="group.type.id">
              <div :class="s.passenger_type_wrap">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ group.type.label || group.type.name }}</div>
                  <div class="d-flex align-items-center">
                    <div :class="s.buttons">
                      <div
                        :class="[s.gray, s.mt_0]"
                        @click="handlePassenger(group.type.id, 'minus')"><i class="fa-solid fa-minus"/></div>
                    </div>
                    <div :class="s.dp_count">{{ (personsByParentId[group.type.id] || []).length }}</div>
                    <div :class="s.buttons">
                      <div
                        :class="[s.gray, s.mt_0]"
                        @click="handlePassenger(group.type.id, 'plus')"><i class="fa-solid fa-plus"/></div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="(personsByParentId[group.type.id] || []).length && group.options.length"
                  :class="s.passenger_option_select">
                  <div v-for="(person, i) in personsByParentId[group.type.id]" :key="i">
                    <i class="fa-solid fa-user"></i>
                    <select class="form-control" v-model="person.optionTypeId">
                      <option :value="null">--</option>
                      <option
                        v-for="opt in group.options"
                        :key="opt.id"
                        :value="opt.id">{{ opt.label || opt.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center">
            <p class="fw-bold">確定料金</p>
            <div :class="s.buttons" class="ms-auto me-0">
              <button
                :disabled="flag.loading.getFare || isPriceLocked"
                :class="[s.blue, s.mt_0]" @click="reCalculateFare">
                <i v-if="flag.loading.getFare" class="fa-solid fa-spinner fa-spin"></i>
                <span v-if="!flag.loading.getFare">再計算</span>
              </button>
            </div>
          </div>
          <div :class="s.type">
            <input :class="s.input" type="text" v-model="priceInput" :disabled="isPriceLocked" @input="onPriceInput">
            <span :class="s.unit">円</span>
          </div>
          <div class="mt-2">
            <label class="d-flex align-items-center">
              <input type="checkbox" v-model="priceConfirmed" :disabled="isPriceLocked">
              <span class="ms-2">料金を確定する</span>
            </label>
            <div v-if="isPriceLocked" class="fs-sm mt-1">※ 料金は確定済みのため変更できません。</div>
          </div>
          <div class="mt-3" v-if="discounts.length">
            <div class="d-flex align-items-center">
              <p class="fw-bold">割引</p>
            </div>

            <div class="d-flex mt-1 align-items-center">
              <select name="" id="" class="flex-1 form-control" v-model="discountId" :disabled="isPriceLocked">
                <option :value="null">割引なし</option>
                <option
                  v-for="d in discounts" :key="d.id"
                  :value="d.id">{{ d.label }}</option>
              </select>
              <div :class="s.buttons" class="ms-auto me-0">
                <button
                  :disabled="flag.loading.getFare || isPriceLocked"
                  :class="[s.blue, s.mt_0]" @click="updateResult({ closeModal: false })">
                  <i v-if="flag.loading.getFare" class="fa-solid fa-spinner fa-spin"></i>
                  <span v-if="!flag.loading.getFare">適用する</span>
                </button>
              </div>
            </div>
            <div class="mt-1 p-2 bg-gray rounded-1" v-if="discountedPrice !== ''">
              <div class="d-flex justify-content-between">
                <div class="fw-bold">割引適用後運賃</div>
                <div><span class="fw-bold">{{ displayedDiscountedPrice }}</span> 円</div>
              </div>
              <div class="fs-sm mt-2">※ 運賃を再計算した場合、再度「適用する」を押してください。</div>
            </div>
          </div>
        </div>

        <div v-if="paymentMethods.length" class="mt-4">
          <div class="d-flex align-items-center">
            <p class="fw-bold">支払い方法</p>
          </div>
          <div>
            <div v-for="pm in paymentMethods" :key="pm.id" class="d-flex align-items-center justify-content-between mt-2">
              <div>{{ pm.label }}</div>
              <div>
                <div class="d-flex align-items-center">
                  <div :class="s.buttons">
                    <button
                      type="button"
                      :class="[s.gray, s.mt_0]"
                      :disabled="paymentMethods.length < 2"
                      @click="handlePaymentAmount(pm, 'minus')"><i class="fa-solid fa-minus"/></button>
                  </div>
                  <div :class="s.pm_amount">{{ (amountPerPaymentMethods[pm.id] || 0).toLocaleString() }}</div>
                  <div :class="s.buttons">
                    <button
                      type="button"
                      :class="[s.gray, s.mt_0]"
                      :disabled="paymentMethods.length < 2"
                      @click="handlePaymentAmount(pm, 'plus')"><i class="fa-solid fa-plus"/></button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isPaymentAmountValid" class="text-danger fs-sm mt-2">
              支払い方法の合計を {{ expectedPaymentAmount.toLocaleString() }} 円に合わせてください
            </div>
          </div>
        </div>

        <div class="mt-4 pt-4 bdr-t bdr-bold">
          <div class="d-flex align-items-center">
            <div class="mx-auto">
              <large-btn
                :style="{
                  height: '100px',
                  width: '200px',
                }"
                :disabled="flag.loading.getFare || !readySubmit || !isPaymentAmountValid"
                @click="updateResult()">確定</large-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-if="data.showThanksMessage && flag.registedOrderResult">
        <div>
          <p class="text-center fs-xl">お疲れ様でした！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LargeBtn from '../../parts/LargeBtn.vue';
import buildPassengerTypeGroups from '../../../utils/passengerTypeGroups';
import adjustPaymentAmount, { findDefaultPaymentMethod } from '../../../utils/paymentMethodAmounts';

export default {
  name: 'PassengerResults',
  props: ['data'],
  components: {
    LargeBtn,
  },
  data() {
    return {
      flag: {
        loading: {
          getContext: false,
          getFare: false,
        },
        registedOrderResult: false,
      },
      passenger: null,
      area: null,
      dispatchPassengers: [],
      additionalDefinitions: [],
      customerPaymentMethods: [],
      passengerResult: null,
      price: 0,
      distance: null,
      priceInput: '',
      discountedPrice: '',
      discountId: null,
      priceConfirmed: false,
      // 親の乗客タイプ id → 乗客1人ずつ（optionTypeId: 選んだオプションの乗客タイプ id。null は親のまま）
      personsByParentId: {},
      passengerTypes: [],
      amountPerPaymentMethods: {},
    };
  },
  created() {
    if (this.data.passengerId && this.data.dispatchId) {
      this.getContext();
    } else {
      alert('処理中にエラーが発生しました。');
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    }
  },
  computed: {
    ...mapState(['user']),
    readySubmit() {
      return Object.values(this.passengerCountByTypeId).some((c) => c > 0);
    },
    passengerTypeGroups() {
      return buildPassengerTypeGroups(this.passengerTypes);
    },
    /** 乗客タイプ id → 人数（保存・再計算用。オプションを選んだ人はオプションの乗客タイプで数える） */
    passengerCountByTypeId() {
      const counts = {};
      Object.entries(this.personsByParentId).forEach(([parentId, persons]) => {
        persons.forEach((person) => {
          const typeId = person.optionTypeId || Number(parentId);
          counts[typeId] = (counts[typeId] || 0) + 1;
        });
      });
      return counts;
    },
    // DB上で既に料金確定済み（price_confirmed = 1）の場合は料金変更不可
    isPriceLocked() {
      return Number(this.passengerResult?.price_confirmed) === 1;
    },
    // areas.reservation_type: 1=タクシー / 2=デマンド
    isDemandArea() {
      return Number(this.area?.reservation_type) === 2;
    },
    discounts() {
      return this.area?.discounts || [];
    },
    paymentMethods() {
      return this.area?.office?.paymentMethods || this.area?.office?.payment_methods || [];
    },
    displayedDiscountedPrice() {
      if (!this.discountId) return this.formatPrice(this.price);
      return this.discountedPrice !== '' ? this.discountedPrice : this.formatPrice(this.price);
    },
    expectedPaymentAmount() {
      const raw = String(this.displayedDiscountedPrice || '').replace(/,/g, '');
      const value = Number(raw);
      return Number.isFinite(value) ? value : 0;
    },
    paymentAmountTotal() {
      return Object.values(this.amountPerPaymentMethods)
        .reduce((sum, amount) => sum + (Number(amount) || 0), 0);
    },
    isPaymentAmountValid() {
      return this.paymentAmountTotal === this.expectedPaymentAmount || !this.paymentMethods.length;
    },
  },
  watch: {
    /** 運賃（割引適用・手入力・再読込）が変わって内訳の合計と合わなくなったら、既定の支払い方法に寄せ直す */
    expectedPaymentAmount(value) {
      if (!this.paymentMethods.length) return;
      if (this.paymentAmountTotal === value) return;
      this.resetPaymentAmountsByDefault();
    },
  },
  methods: {
    // 親の乗客タイプの人数を増減する（減らすときは後ろの人から）
    handlePassenger(parentId, handleType) {
      const persons = [...(this.personsByParentId[parentId] || [])];
      if (handleType === 'minus') {
        persons.pop();
      } else {
        persons.push({ optionTypeId: null });
      }
      this.personsByParentId = { ...this.personsByParentId, [parentId]: persons };
    },
    /** 支払い方法の金額を unit ずつ増減し、差分を既定の支払い方法（既定を押したときは他の支払い方法）で吸収する */
    handlePaymentAmount(pm, direction) {
      this.amountPerPaymentMethods = adjustPaymentAmount({
        paymentMethods: this.paymentMethods,
        amounts: this.amountPerPaymentMethods,
        target: pm,
        direction,
      });
    },

    showLoading() {
      this.$store.dispatch('modal/loadings/showModal', { modalName: 'modalLoadingBallScaleRippleMultiple' }, { root: true });
    },
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getContext() {
      this.flag.loading.getContext = true;
      this.axios({
        method: 'GET',
        url: '/v1/dispatch/get/detail',
        params: {
          id: this.data.dispatchId,
          withPassengers: 1,
          withSchedule: 1,
          withSlot: 1,
          withAdditionals: 1,
        },
      })
        .then((response) => {
          const dispatch = response.data.dispatch || null;
          const passenger = dispatch?.passengers?.find((p) => p.id === this.data.passengerId) || null;
          const area = dispatch?.schedule?.area || dispatch?.slot?.area || null;

          this.passenger = passenger;
          this.area = area;
          // 実績確定後の運行データモーダル自動表示の判定用
          this.dispatchPassengers = dispatch?.passengers || [];
          this.additionalDefinitions = area?.dispatchAdditionalDefinitions || [];
          this.customerPaymentMethods = passenger?.customerPaymentMethods || [];
          const passengerResults = passenger?.passengerResults || [];
          this.passengerResult = [...passengerResults].sort((a, b) => b.id - a.id)[0] || null;
          this.setInitData();
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.$store.dispatch('modal/contents/hideModal', null, { root: true });
        })
        .finally(() => {
          this.flag.loading.getContext = false;
        });
    },

    setInitData() {
      const ptList = this.area?.passengerTypes || this.area?.passenger_types || [];
      this.passengerTypes = Array.isArray(ptList) ? ptList : [];

      // 親の乗客タイプごとに、乗客を1人ずつ並べる（オプションの人数は親の下にオプション付きで並べる）
      const parentIdOf = {};
      const persons = {};
      this.passengerTypeGroups.forEach((group) => {
        persons[group.type.id] = [];
        parentIdOf[group.type.id] = group.type.id;
        group.options.forEach((opt) => { parentIdOf[opt.id] = group.type.id; });
      });

      const passengerCounts = this.passenger?.passengerCounts || this.passenger?.passenger_counts || [];
      const hasResultRecord = passengerCounts.some((pc) => pc.record_type === 21);
      const countsToUse = hasResultRecord
        ? passengerCounts.filter((pc) => pc.record_type === 21)
        : passengerCounts.filter((pc) => pc.record_type === 11);

      countsToUse.forEach((pc) => {
        const typeId = pc.passenger_type_id;
        const parentId = parentIdOf[typeId];
        if (!parentId) return;
        for (let i = 0; i < (pc.count || 0); i += 1) {
          persons[parentId].push({ optionTypeId: typeId === parentId ? null : typeId });
        }
      });
      // オプションの無い人を先に、オプションを選んだ人を後ろに並べる
      Object.values(persons).forEach((list) => list.sort((a, b) => Number(Boolean(a.optionTypeId)) - Number(Boolean(b.optionTypeId))));
      this.personsByParentId = persons;

      this.priceConfirmed = Number(this.passengerResult?.price_confirmed) === 1;
      this.price = this.passengerResult?.price ?? this.passenger?.price ?? 0;
      this.distance = this.passengerResult?.distance ?? null;
      this.priceInput = this.formatPrice(this.price);
      this.discountedPrice = this.passengerResult?.price_discounted != null ? this.formatPrice(this.passengerResult.price_discounted) : this.formatPrice(this.price);

      const passengerDiscounts = this.passenger?.passengerDiscounts || this.passenger?.passenger_discounts || [];
      const latestPassengerDiscount = [...passengerDiscounts].sort((a, b) => b.id - a.id)[0] || null;
      this.discountId = latestPassengerDiscount?.discount_id ?? null;
      if (!this.discountId) this.discountedPrice = this.formatPrice(this.price);

      const pms = this.paymentMethods;
      if (this.customerPaymentMethods.length && pms.length) {
        const amounts = {};
        pms.forEach((pm) => {
          amounts[pm.id] = 0;
        });
        this.customerPaymentMethods.forEach((cpm) => {
          // 事業所のマスタに無い支払い方法は読み飛ばす（画面に出ない金額が合計に残らないように）
          if (!(cpm.payment_method_id in amounts)) return;
          amounts[cpm.payment_method_id] = cpm.amount || 0;
        });
        this.amountPerPaymentMethods = amounts;
      } else if (pms.length) {
        this.resetPaymentAmountsByDefault();
      }
      if (pms.length === 1) this.resetPaymentAmountsByDefault();
    },

    onPriceInput(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9０-９]/g, '');
      value = value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
      const numericValue = parseInt(value, 10);
      this.price = isNaN(numericValue) ? 0 : numericValue;
      this.priceInput = this.formatPrice(this.price);
    },

    formatPrice(value) {
      if (value == null) return '';
      return Number(value).toLocaleString('ja-JP');
    },

    async fetchDistanceForFare(pickup, destination) {
      const distanceResponse = await this.axios({
        method: 'POST',
        url: '/v1/helper/get/distanceDuration',
        params: {
          p_lat: pickup.lat,
          p_lng: pickup.lng,
          d_lat: destination.lat,
          d_lng: destination.lng,
          noGenerateMap: true,
        },
      });
      const distance = distanceResponse?.data?.distance;
      if (!distance) throw new Error('distance not found');
      return distance;
    },

    fetchRecalculatedFare({ distance, rideStartDatetime }) {
      return this.axios({
        method: 'POST',
        url: '/v1/dispatch/taxi/recalculate-fare',
        data: {
          area_id: this.area?.id,
          distance,
          rideStartDatetime,
        },
      });
    },

    reCalculateFare() {
      // デマンドエリアは距離制のタクシー運賃ではなく、予約時と同じデマンド料金計算を使う
      if (this.isDemandArea) {
        this.reCalculateDemandFare();
        return;
      }

      this.flag.loading.getFare = true;
      const passengerLocations = this.passenger?.passengerLocations || [];

      const sorted = [...passengerLocations].sort(
        (a, b) => new Date(String(a.datetime)).getTime() - new Date(String(b.datetime)).getTime(),
      );

      if (sorted.length < 2) {
        alert('乗降地点情報が不足しています。再度お試しください。');
        this.flag.loading.getFare = false;
        return;
      }

      const pickup = sorted[0];
      const destination = sorted[sorted.length - 1];

      // 既存の「割引適用前の再計算」APIを呼ぶため、距離を先に取得する
      this.fetchDistanceForFare(pickup, destination)
        .then((distance) => {
          this.distance = distance;
          return this.fetchRecalculatedFare({
            distance,
            rideStartDatetime: pickup.datetime,
          });
        })
        .then((fareResponse) => {
          const res = fareResponse.data;
          const fareDetail = res?.fare;
          if (fareDetail?.total != null) {
            this.price = fareDetail.total;
            this.priceInput = this.formatPrice(this.price);
          }

          // 支払い内訳を価格に合わせてリセット
          if (this.paymentMethods.length) {
            this.resetPaymentAmountsByDefault();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.flag.loading.getFare = false;
        });
    },

    /** デマンド料金の再計算（モーダル上の乗車人数と保存済み乗降地点で計算） */
    reCalculateDemandFare() {
      const passengerCount = {};
      this.passengerTypes.forEach((pt) => {
        const count = Number(this.passengerCountByTypeId[pt.id]) || 0;
        if (pt.name && count > 0) passengerCount[pt.name] = count;
      });

      if (!Object.keys(passengerCount).length) {
        alert('乗車人数を入力してください');
        return;
      }

      this.flag.loading.getFare = true;
      this.axios({
        method: 'POST',
        url: '/v1/dispatch/demand/recalculate-fare',
        data: {
          area_id: this.area?.id,
          passenger_id: this.data.passengerId,
          passenger_count: passengerCount,
        },
      })
        .then((response) => {
          const res = response.data;
          if (res.price != null) {
            this.price = res.price;
            this.priceInput = this.formatPrice(this.price);
          }
          // 距離制運賃エリア（奥尻）は距離も更新される
          if (res.distance != null) this.distance = res.distance;

          // 支払い内訳を価格に合わせてリセット
          if (this.paymentMethods.length) {
            this.resetPaymentAmountsByDefault();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.flag.loading.getFare = false;
        });
    },

    resetPaymentAmountsByDefault() {
      if (!this.paymentMethods.length) return;
      const defaultId = findDefaultPaymentMethod(this.paymentMethods)?.id;
      const amounts = {};
      this.paymentMethods.forEach((pm) => {
        amounts[pm.id] = pm.id === defaultId ? this.expectedPaymentAmount : 0;
      });
      this.amountPerPaymentMethods = amounts;
    },

    buildPassengerCountsPayload() {
      return Object.entries(this.passengerCountByTypeId)
        .filter(([, count]) => Number(count) > 0)
        .map(([passengerTypeId, count]) => ({
          passenger_type_id: Number(passengerTypeId),
          count: Number(count),
        }));
    },

    buildCustomerPaymentMethodsPayload() {
      const arr = [];
      Object.entries(this.amountPerPaymentMethods).forEach(([paymentMethodId, amount]) => {
        if (Number(amount) > 0) {
          arr.push({ payment_method_id: Number(paymentMethodId), amount: Number(amount) });
        }
      });
      return arr;
    },

    hideModal(actionType) {
      const payload = { type: actionType?.type || 'cancel', data: {} };
      if (actionType?.type === 'update') {
        payload.data = { type: 'passengerResultUpdate', passengerId: this.data.passengerId };
      }
      this.$store.dispatch('modal/contents/hideModal', payload, { root: true });
      this.hideLoading();
    },

    completedOrderResult() {
      this.hideLoading();

      // 最後の乗客なら実績確定 → 運行データ入力 → お疲れ様でした の順にする
      // （お疲れ様の表示は運行データモーダルの保存後に出す）
      if (this.shouldOpenAdditionalsModal()) {
        this.hideModal({ type: 'update' });
        this.openAdditionalsModal();
        return;
      }

      if (this.data.showThanksMessage) {
        this.flag.registedOrderResult = true;
        setTimeout(() => this.hideModal({ type: 'update' }), 3000);
      } else {
        this.hideModal({ type: 'update' });
      }
    },

    /**
     * 実績確定後に運行データ（dispatchAdditionals）の入力モーダルを開くか。
     * この乗客が配車（dispatch）の最後の乗客（有効乗客が全員完了）で、
     * area に有効な定義がある場合のみ開く。
     */
    shouldOpenAdditionalsModal() {
      if (!this.additionalDefinitions.length) return false;
      const activePassengers = this.dispatchPassengers.filter((p) => p.flag < 900);
      if (!activePassengers.length) return false;
      return activePassengers.every((p) => p.flag >= 31);
    },

    openAdditionalsModal() {
      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'DispatchAdditionals',
        modalTitle: '運行データ',
        data: {
          dispatchId: this.data.dispatchId,
          // お疲れ様メッセージは運行データの保存後に表示する
          showThanksMessage: this.data.showThanksMessage,
        },
      }, { root: true });
    },

    updateResult(option = { closeModal: true }) {
      if (!Number.isInteger(this.price)) {
        alert('料金は数字で入力してください');
        return;
      }
      if (!this.isPaymentAmountValid) {
        alert(`支払い方法の合計を ${this.expectedPaymentAmount.toLocaleString()} 円に合わせてください`);
        return;
      }
      if (!this.readySubmit) {
        alert('乗車人数と料金を入力してください');
        return;
      }
      this.showLoading();

      const data = {
        user_id: this.user?.id,
        passenger_id: this.data.passengerId,
        price: this.price,
        distance: this.distance,
        discount_id: this.discountId,
        price_confirmed: this.priceConfirmed ? 1 : 0,
        passenger_counts: this.buildPassengerCountsPayload(),
        customer_paymentMethods: this.paymentMethods.length ? this.buildCustomerPaymentMethodsPayload() : undefined,
      };

      this.axios({
        method: 'POST',
        url: '/v1/passengerResult/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (!option.closeModal) {
            this.getContext();
            this.hideLoading();
            return;
          }
          if (res.updated || res.passengerResultId) {
            this.completedOrderResult();
          } else {
            alert('エラーが発生しました。再度お試しください。');
            this.hideLoading();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
}
.buttons {
  height: 100%;
  text-align: center;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    margin: 8px 4px 0;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.mt_0 {
      margin-top: 0;
    }
    &.blue {
      background-color: var(--primary-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}
.type {
  display: flex;
  align-items: baseline;
  .input {
    width: 95%;
    height: 50px;
    font-size: 24px;
    text-align: right;
    padding-right: 15px;
    margin-top: 8px;
    border: 1px solid var(--bs-gray);
    border-radius: 3px;
  }
  .unit {
    font-size: 18px;
    font-weight: bold;
    margin-left: 10px;
  }
}
.passenger_type_wrap {
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 6px;
  background-color: var(--bg-gray);
}
.dp_count {
  width: 100px;
  text-align: center;
  padding: 0 0.8rem;
  margin: 0 0.2rem;
  background-color: #ffffff;
  border-radius: 6px;
}
.pm_amount {
  width: 120px;
  text-align: center;
  padding: 0 0.8rem;
  margin: 0 0.2rem;
}
.passenger_option_select {
  display: flex;
  flex-wrap: wrap;
  > * {
    position: relative;
    width: 200px;
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    margin-top: 8px;
    select {
      padding-left: 52px;
    }
    i {
      position: absolute;
      top: 50%; left: 0;
      translate: 0 -50%;
      font-size: 30px;
      margin-left: 12px;
    }
  }
}
</style>
